import { useState, useEffect, useContext, useRef } from 'react';

import { PracticeReseveContext } from '../../../../../PracticeReseveContext';

import {
  formatTime, formatTimeAddMin
} from '../../../../../../../../util/utility';


function PracticeReserveDatetimeModalTime(props: any) {

  const {
    lsnMin, selectedScheduleId, setSelectedScheduleId,
  } = useContext(PracticeReseveContext);

  const dateKey = props.dateKey;
  const timeKey = props.timeKey;
  const timeInfo = props.timeInfo;



  return (
    <li className="list-group-item" key={timeKey}>
      <label
        htmlFor={`c_${dateKey}${timeKey}`}
        style={{ width: '100%', height: '100%' }}
      >
        {formatTime(timeKey)} 〜 {formatTimeAddMin(timeKey, lsnMin)}
        {timeKey >= '00:00:00' && timeKey < '05:00:00' && ' (深夜)'}
        {timeKey >= '05:00:00' && timeKey < '08:00:00' && ' (早朝)'}
      </label>
      <span className="radio home-checkbox">
        <input
          id={`c_${dateKey}${timeKey}`}
          type="radio"
          style={{
            top: '-10px',
            right: 0,
            zIndex: 1,
          }}
          name="sche_id"
          value={timeInfo}
          checked={selectedScheduleId === timeInfo}
          onChange={() => setSelectedScheduleId(timeInfo)}
        />
      </span>
    </li>
  );
}
  
export default PracticeReserveDatetimeModalTime;